import React from 'react';
import { motion } from 'framer-motion';
import { Zap, Shield } from 'lucide-react';
import { CTAButton } from '../ui/CTAButton';
export function FinalCTA() {
  const scrollToOffer = () => {
    document.getElementById('offer')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="w-full bg-navy-primary py-12 md:py-20 px-4 md:px-6" data-id="element-96">
      <div className="max-w-4xl mx-auto text-center" data-id="element-97">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-98">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-display font-bold text-white mb-4 md:mb-6" data-id="element-99">
            พร้อมที่จะเปลี่ยนแปลงการสอนของคุณแล้วหรือยัง?
          </h2>
          <p className="text-base md:text-xl text-gray-300 mb-6 md:mb-8" data-id="element-100">
            เข้าร่วมกับอาจารย์กว่า 1,200 ท่านที่เลือกใช้ระบบนี้
          </p>

          <CTAButton onClick={scrollToOffer} size="large" className="mb-6 w-full sm:w-auto" data-id="element-101">
            ⚽ ใช่! ฉันต้องการคืนเวลาของตัวเอง
            <br className="hidden sm:block" data-id="element-102" />
            และสอนฟุตบอลได้อย่างมืออาชีพ
          </CTAButton>

          <div className="flex flex-wrap justify-center gap-3 md:gap-4 text-xs md:text-sm text-gray-300" data-id="element-103">
            <span className="flex items-center gap-1" data-id="element-104">
              <Zap className="w-3.5 h-3.5 md:w-4 md:h-4 text-gold-accent" data-id="element-105" />
              เข้าถึงได้ทันที
            </span>
            <span className="flex items-center gap-1" data-id="element-106">
              <Shield className="w-3.5 h-3.5 md:w-4 md:h-4 text-gold-accent" data-id="element-107" />
              รับประกัน 7 วัน
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}